<template>
	<div class="page_content strm_cat_view" aria-label="Stream Category view content page">
		<div class="row page-heading">
			<div class="col-7 input module_heading" :class="[showEntity ? 'entity-heading' : '']">
			  <span class="module_icon icon-stream"></span>
			  <label class="head_txt module_type_name stream-title ace_sec_hd" role="heading" :aria-label="stream.title"><span v-if="advisorTitle">{{advisorTitle}}: </span>{{stream.title}}</label>
			  <label class="head_txt module_type_name ace_sec_hd" v-if="showEntity" role="heading" :aria-label="entity.title"> <span class="separator">::</span> {{entity.title}}</label>
			</div>
			<div class="col-5 right-container">
				<stream-header :uuid="uuid" active="category"></stream-header>
			</div>
		</div>
		<div class="page-content">
			<stream-menu :uuid="uuid" active="category"></stream-menu>
			<div class="col-12 dasboard-left-section" v-if="isProgramGuideAvailable">
				<div class="stream-view-section">
				    <div class="row" :class="[showCategory ? 'toc-on-show-category' : '']">
  						<div class="table-of-content-column ace_sec" aria-label="Stream TOC Section">
  							<div class="table-header">
  							  <span class="list-icon icon-list"></span>
  							  <span class="title ace_sec_txt" @click ="loadStream" :aria-label="stream.title" :title="stream.title">{{stream.title}}</span>
  							</div>

  							<div class="toc_tree_panel table-of-content-section">
              					<ul class="toc_container category_tree">
									<node-category-tree :node="substream" :isCategoryView="true" v-for="substream in structure"></node-category-tree>
              					</ul>
  							</div>
  						</div>

              <template v-if="!showEntity && !showCategory">
    						<div class="thumbnail_panel ace_sec" aria-label="Thumbnail Section">
    							<div class="thumbnail_container ace_sec_txt" aria-label="default image" style="padding-bottom: 30px;">
    								<div class="default" v-if="!streamThumbnail">
    									<div class="thumbnail">
    										<div class="thumbnail_icon icon-stream"></div>
                      </div>
    								</div>
										<div v-if="streamThumbnail">
											<img class="thumbnail_icon" :src="streamThumbnail" style="width: 100%; height: auto;">
										</div>
    								<div class="entity-row">
                                      <!--
    									<div class="entity-column">
    										<span class="icon-course icon"></span>
    										<span class="entity-value">1</span>
    									</div>
    									<div class="more-link">more</div>
                                       -->
    								</div>
    							</div>
                  <!--
    							<div class="content-row ace_sec_txt" :aria-label="'Stream Created By ' + stream.ownerName">
    								<div class="heading">Stream Created By</div>
    								<div class="result-value">{{stream.ownerName}}</div>
    							</div>
                  -->
                                  <!--
    							<div class="content-row extract-info">
    								<div class="heading">
    									<span class="icon-extract"></span>
    									<span class="tag-heading">Extracted Info</span>
    								</div>
    								<div class="result-value">
    									<div class="tags">
    										<span class="tag">watson</span>
    									</div>
    									<div class="tags">
    										<span class="tag">watson 17th</span>
    									</div>
    								</div>
    							</div>
                                   -->
    							<div class="content-row general-tag" v-if="generalTags.length > 0">
    								<div class="heading">
    									<span class="ic-tag"></span>
    									<span class="tag-heading ace_sec_txt" aria-label="General">General</span>
    								</div>
    								<div class="result-value">
    								  <div class="tags" v-for="tag in generalTags">
    									<span class="tag ace_sec_txt" :aria-label="tag.name">{{tag.name}}</span>
    								  </div>
    								</div>
    							</div>

    						</div>
                <div class="description-column">
                  <div class="page-section">
      							<template v-if="advisorName">
      								<div class="page_section_row">
      									<div class="heading" role="heading" aria-label="Advisor" tabindex="0">
      										<label>Advisor</label>
      									</div>
      									<div class="page_content_block" :aria-label="advisorName" tabindex="0">
      										{{advisorName}}
      									</div>
      								</div>
      							</template>

      							<template v-if="specialNotes.length > 0" v-for="specialNote in specialNotes">
      								<div class="page_section_row">
      									<div class="heading ace_sec_hd" role="heading" :aria-label="specialNote.title">
      										<label>{{specialNote.title}}</label>
      									</div>
      									<div class="page_content_block ace_sec_txt">
      										Required {{specialNote.required}}/ Used {{specialNote.used}}/ Needed {{specialNote.needed}}
      									</div>
      								</div>
      							</template>
                    <template v-if="stream.description">
      								<div class="page_section_row">
      									<div class="heading ace_sec_hd" role="heading" aria-label="Description">
      										<label>Description</label>
      									</div>
      									<div class="page_content_block">
      										<div class="courseDesc ace_sec_txt" :aria-label="stream.description" v-html="stream.description"></div>
      									</div>
      								</div>
      							</template>
    						  </div>
    					  </div>
              </template>
              <template v-if="showEntity">
                <div class="thumbnail_panel ace_sec" aria-label="Thumbnail Section">
                  <div class="thumbnail_container ace_sec_txt">
                    <template v-if="entity.thumbnail">
                      <div class="thumbnail_icon">
                         <img :src="entity.thumbnail">
                      </div>
                    </template>
                		<template v-else>
                			<div class="default">
          							<div class="thumbnail">
          								  <div class="thumbnail_icon icon-course" v-if="entity.entityType === 'deliverycontext'"></div>
          								  <div class="thumbnail_icon icon-catalog" v-if="entity.entityType === 'catalog'"></div>
          								  <div class="thumbnail_icon icon-job" v-if="entity.entityType === 'job'"></div>
          								  <div class="thumbnail_icon icon-event" v-if="entity.entityType === 'event'"></div>
          								  <div class="thumbnail_icon icon-club" v-if="entity.entityType === 'club'"></div>
          							</div>
    					        </div>
                		</template>
    								<div class="entity-row">
                                       <!--
    									<div class="entity-column">
    										<span class="icon-course icon"></span>
    										<span class="entity-value">1</span>
    									</div>
    									<div class="more-link">more</div>
                                        -->
    								</div>
    							</div>
                  <div class="content-row ace_sec_txt" :aria-label="'Instructor ' + instructorName" v-if="instructorName">
          					<div class="heading">Instructor</div>
          					<div class="result-value">{{instructorName}}</div>
        			    </div>
                  <div class="content-row ace_sec_txt" :aria-label="'Location ' + entity.roomInformation" v-if="entity.roomInformation">
                    <div class="heading">Location</div>
                    <div class="result-value">{{entity.roomInformation}}</div>
                  </div>
                  <div class="content-row ace_sec_txt" :aria-label="'Meeting Day ' + meetingDays" v-if="meetingDays">
                    <div class="heading">Meeting Days</div>
                    <div class="result-value">{{meetingDays}}</div>
                  </div>
                  <div class="content-row ace_sec_txt" :aria-label="'Meeting Times ' + meetingTimes" v-if="meetingTimes">
                    <div class="heading">Meeting Times</div>
                    <div class="result-value">{{meetingTimes}}</div>
                  </div>
                  <div class="content-row ace_sec_txt" :aria-label="'CRN ' + crn" v-if="crn">
                    <div class="heading">CRN</div>
                    <div class="result-value">{{crn}}</div>
                  </div>
                  <div class="content-row ace_sec_txt" :aria-label="'Section ' + section" v-if="section">
                    <div class="heading"> Section #</div>
                    <div class="result-value">{{section}}</div>
                  </div>
                </div>
                <div class="description-column">
                  <div class="page-section">
          					<template v-if="entity.description">
          						<div class="page_section_row">
          							<div class="heading ace_sec_hd" role="heading" aria-label="Description">
          								<label>Description</label>
          							</div>
          							<div class="page_content_block">
          								<div class="courseDesc ace_sec_txt" :aria-label="entity.description" v-html="entity.description"></div>
          							</div>
          						</div>
          					</template>
    				      </div>
                </div>
              </template>
              <template v-if="showCategory">
                <div class="description-column category-details">
                  <div class="entity-nav">
                    <span class="icon icon-stream"></span>
                    <span class="entity-title ace_sec_txt" :aria-label="category.title">{{category.title}}</span>
                  </div>

                  <div class="entity-cont-section">
                    <div class="content-row" v-if="(required > 0 || taken > 0 || needed > 0) && showCategoryDetail">
                      Courses - Required <span tabindex="0">{{required}}</span> / Taken <span class="ace_sec_txt">{{taken}}</span> / Needed <span class="ace_sec_txt">{{needed}}</span>
                    </div>
                    <div class="cont-row red-text" v-if="!showCategoryDetail">
                      Minimum 18 quarter units in at least 2 of the following areas: Arts, Humanities, Foreign Language
                    </div>
                    <template v-if="categories.length > 0 && !category.isLeafCategory">
                      <category v-for="category in categories" :category="category"></category>
                    </template>
                    <template  v-if="categories.length > 0 && category.isLeafCategory">
                      <category-table :categories="categories"></category-table>
                    </template>
                  </div>
                </div>
              </template>
				    </div>
				</div>
			</div>
      <div class="col-12 dasboard-left-section" v-else>
        <div class="course-description col-12">
          <b-jumbotron>
            <h4 class="text-center ace_sec_txt" aria-label="Category View is currently not available">Category View is currently not available.</h4>
            <p class="text-center ace_sec_txt" aria-label="Please reach out to your institutional admin to unlock the Category View">Please reach out to your institutional admin to unlock the Category View.</p>
          </b-jumbotron>
        </div>
      </div>
    </div>
	</div>
</template>

<script>
import '../../../assets/module/css/stream/streamView.min.css'
import { mapState, mapActions } from 'vuex'
import StreamMenu from './StreamMenu'
import StreamHeader from './StreamHeader'
import NodeCategoryTree from './NodeCategoryTree'
import Category from './Category'
import CategoryTable from './CategoryTable'

export default {
  name: 'streamCategory',
  props: ['uuid'],
  components: {
    StreamMenu,
    NodeCategoryTree,
    Category,
    CategoryTable,
    StreamHeader
  },
  data: () => {
    return {
      uObj: JSON.parse(localStorage.getItem('userobj')),
      userrole: localStorage.getItem('userrole'),
      specialNotes: []
    }
  },
  mounted () {
    this.loadStream()
  },
  methods: {
    ...mapActions([
      'loadStreamDetail',
      'loadUserAdvisor',
      'loadLogDashboardActivity',
      'loadStudentSpecialNotes'
    ]),

    async loadStream () {
      this.loadLogDashboardActivity({action: 'viewStreamCategoryView', page: 'streamCategoryView', link: '', entityUuid: this.uuid})
      this.loadStreamDetail(this.uuid).then(res => {
        this.loadUserAdvisor(this.stream.ownerId)
      })
      this.specialNotes = await this.loadStudentSpecialNotes()
    }
  },
  computed: {
    ...mapState({
      'stream': state => state.stream.stream,
      'advisor': state => state.user.advisor,
      'showEntity': state => state.stream.showEntity,
      'entity': state => state.stream.entity,
      'showCategory': state => state.stream.showCategory,
      'category': state => state.stream.category
    }),
    showCategoryDetail () {
      if (this.category.title.indexOf('Arts') > -1 || this.category.title.indexOf('Humanities') > -1 || this.category.title.indexOf('Foreign ') > -1) {
        if (this.taken === 0) {
          return false
        }
        return true
      }
      return true
    },
    structure () {
      if (this.stream && this.stream.contentViewStructure) {
        return JSON.parse(this.stream.contentViewStructure)
      } else {
        return []
      }
    },
    isProgramGuideAvailable () {
      if (this.stream && this.stream.programGuides && this.stream.programGuides.length > 1) {
        return true
      } else {
        return false
      }
    },
    major () {
      if (this.uObj && this.uObj.major1Title) {
        return this.uObj.major1Title
      }
      return ''
    },
    generalTags () {
      if (this.stream.appliedTagMap && this.stream.appliedTagMap.general) {
        return this.stream.appliedTagMap.general
      } else {
        return []
      }
    },
    advisorName () {
      if (this.advisor) {
        return this.advisor.name
      } else {
        return null
      }
    },
    instructorName () {
      if (this.entity.instructorNames) {
        var str = this.entity.instructorNames[0]
        var res = str.split('__')
        var instNames = res[0]
        for (var i = 1; i < this.entity.instructorNames.length; i++) {
          str = this.entity.instructorNames[i]
          res = str.split('__')
          instNames = instNames + ', ' + res[0]
        }
        return instNames
      } else {
        return ''
      }
    },
    meetingDays () {
      var meetingDays = ''
      if (this.entity.meetingDaysRaw && this.entity.meetingDaysRaw.length > 0) {
        meetingDays = meetingDays + this.entity.meetingDaysRaw[0].day
      }

      if (this.entity.meetingDaysRaw && this.entity.meetingDaysRaw.length > 1) {
        meetingDays = meetingDays + ', ' + this.entity.meetingDaysRaw[1].day
      }
      return meetingDays
    },
    meetingTimes () {
      var meetingTimes = ''
      if (this.entity.meetingDaysRaw && this.entity.meetingDaysRaw.length > 0) {
        if (this.entity.meetingDaysRaw[0].meetingFromTime !== null && this.entity.meetingDaysRaw[0].meetingToTime !== null) {
          meetingTimes = meetingTimes + this.entity.meetingDaysRaw[0].meetingFromTime + '-' + this.entity.meetingDaysRaw[0].meetingToTime
        }
      }

      if (this.entity.meetingDaysRaw && this.entity.meetingDaysRaw.length > 1) {
        if (this.entity.meetingDaysRaw[1].meetingFromTime !== null && this.entity.meetingDaysRaw[1].meetingToTime !== null) {
          meetingTimes = meetingTimes + ', ' + this.entity.meetingDaysRaw[1].meetingFromTime + '-' + this.entity.meetingDaysRaw[1].meetingToTime
        }
      }
      return meetingTimes
    },
    crn () {
      if (this.entity.crn) {
        return this.entity.crn
      } else {
        return ''
      }
    },
    section () {
      if (this.entity.num) {
        return this.entity.num
      } else {
        return ''
      }
    },
    categories () {
      if (this.category && this.category.contentViewStructure) {
        return JSON.parse(this.category.contentViewStructure)
      }
      return []
    },
    required () {
      if (this.category && this.category.minimumCourses) {
        return this.category.minimumCourses
      } else {
        return 0
      }
    },
    taken () {
      if (this.category && this.category.coursesUsed) {
        return this.category.coursesUsed
      } else {
        return 0
      }
    },
    needed () {
      if (this.category && this.category.coursesNotPlanned > -1 && this.category.minimumCourses > this.category.coursesUsed) {
        return this.category.minimumCourses - this.category.coursesUsed
      } else {
        return 0
      }
    },
    advisorTitle () {
      if (this.userrole === 'Advisor' && this.stream && this.stream.ownerName) {
        return '' + this.stream.ownerName + ''
      } else {
        return ''
      }
    },
    streamThumbnail () {
      if (this.stream && this.stream.programGuides && this.stream.programGuides.length > 1) {
        return this.stream.programGuides[1].thumbnailURL
      }
      return ''
    }
  }
}
</script>
<style>
.red-text {
  color: red;
}
</style>



// WEBPACK FOOTER //
// src/app/stream/components/StreamCategory.vue